import React from "react";
import BaseModal from "./BaseModal";

const ConfirmationModal = ({ onClose, dataFromSnippet, onConfirm, onCancel, modalStyles }) => {
  const onConfirmInternal = () => {
    onConfirm();
    onClose();
  };

  const onCancelInternal = () => {
    onCancel();
    onClose();
  };

  const headerChildren = (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold">{dataFromSnippet.headerTitle}</h2>
    </div>
  );

  const bodyChildren = (
    <div className="flex flex-col gap-4">
      <p className="text-[12px] md:text-[14px] lg:text-[16px]">{dataFromSnippet.bodyMessage}</p>
      <div className="flex gap-4 justify-end">
        <button
          className="w-full border text-[12px] md:text-[14px] lg:text-[16px] border-gray-400 text-gray-400 px-2 py-1 rounded-md  font-semibold hover:opacity-80"
          onClick={onCancelInternal}
        >
          {dataFromSnippet.cancelText || "Cancel"}
        </button>
        <button
          className="w-full bg-red-400 text-[12px] md:text-[14px] lg:text-[16px] rounded-md px-2 py-1 text-white font-semibold hover:opacity-80"
          onClick={onConfirmInternal}
        >
          {dataFromSnippet.confirmText || "Confirm"}
        </button>
      </div>
    </div>
  );

  return (
    <BaseModal
      headerChildren={headerChildren}
      bodyChildren={bodyChildren}
      onClose={onClose}
      width="w-3/4 md:w-1/2 xl:w-1/4"
      show={true}
      modalStyles={modalStyles}
    />
  );
};

export default ConfirmationModal;
